import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import AccountActions from "../../../redux/actions/account.actions";
import customerSelector from "../../../redux/selectors/customer.selector";
import utilSelector from "../../../redux/selectors/util.selector";
import PhoneNumberInput from "../../custom/PhoneNumberInput";

const AddressBook = ({
  addresses,
  isCheckout = false,
  // isLoading,
  selectedAddress,
  onSelect,
  customerInfo,
}) => {
  const dispatch = useDispatch();
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  // const [deletingId, setDeletingId] = useState(null);
  const [editingAddress, setEditingAddress] = useState(null);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [addressToDelete, setAddressToDelete] = useState(null);
  const [isPrimaryInfo, setIsPrimaryInfo] = useState(null);
  const countryList = useSelector(utilSelector.countryList);
  const isAddressBeingAdded = useSelector(customerSelector.isAddressBeingAdded);
  const isAddressBeingUpdated = useSelector(
    customerSelector.isAddressBeingUpdated,
  );
  const isAddressBeingRemoved = useSelector(
    customerSelector.isAddressBeingRemoved,
  );
  const [formData, setFormData] = useState({
    addressName: "",
    address: "",
    email: "",
    mobileNo: "",
    countryCode: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    defaultAddress: false,
    id: "",
  });

  const ERROR_MESSAGES = {
    addressName: "Please enter address name",
    address: "Please enter address",
    email: "Please enter email",
    mobileNo: "Please enter mobile no",
    countryCode: "Please enter country code",
    city: "Please enter city",
    state: "Please enter state",
    zip: "Please enter Pincode",
    country: "Please enter country",
  };

  const [formErrorData, setFormErrorData] = useState({
    addressName: "",
    address: "",
    email: "",
    mobileNo: "",
    countryCode: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  });

  useEffect(() => {
    setSelectedAddressId(selectedAddress);
  }, []);

  useEffect(() => {
    if (!isAddressBeingAdded) {
      setIsAddingNew(false);
    }
  }, [isAddressBeingAdded]);

  useEffect(() => {
    if (!isAddressBeingRemoved) {
      setAddressToDelete(null);
    }
  }, [isAddressBeingRemoved]);

  const getOptions = (list, key, value) => {
    const children = [];
    for (let i = 0; i < list.length; i += 1) {
      children.push(
        <option key={list[i][key]} value={list[i][value]}>
          {list[i][value]}
        </option>,
      );
    }
    return children;
  };

  const countryOptions = useMemo(
    () => getOptions(countryList, "country", "country"),
    [countryList],
  );

  const handleChange = (e, inputType) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (inputType === "country" && isCheckout) {
      // updateSC(e, addressType);
    }
    setFormErrorData({
      ...formErrorData,
      [name]: ''
    })
  };

  const sortedAddresses = useMemo(() => {
    return [...addresses].sort((a, b) => {
      if (a.defaultAddress && !b.defaultAddress) return -1;
      if (!a.defaultAddress && b.defaultAddress) return 1;
      return a.addressName.localeCompare(b.addressName);
    });
  }, [addresses]);

  const handleOpenModal = (e, addressToEdit = null) => {
    e.preventDefault();
    if (addressToEdit) {
      setEditingAddress(addressToEdit);

      setFormData(addressToEdit);
      setIsAddingNew(true);
    } else {
      setEditingAddress(null);
      setFormData({
        name: "",
        mobileNo: "",
        email: "",
        countryCode: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
        country: "India",
      });
      setIsAddingNew(true);
    }
    // setIsModalOpen(true);
    // setDeletingId(null);
  };

  useEffect(() => {
    const data = {
      ...formData,
      email: isPrimaryInfo ? customerInfo?.email : "",
      mobileNo: isPrimaryInfo ? customerInfo?.mobile : "",
      countryCode: isPrimaryInfo ? customerInfo?.countryCode : "",
    };
    setFormData(data);
  }, [isPrimaryInfo]);

  const handleSaveAddress = (e) => {
    e.preventDefault();

    if (!editingAddress && !isAddingNew) {
      onSelect(selectedAddressId);
    } else {
      //validate
      let error = false;
      let errorObj = {};
      Object.keys(formErrorData).forEach((key) => {
        if (!formData[key]) {
          error = true;
        }
        errorObj[key] = formData?.[key] ? "" : ERROR_MESSAGES[key];
      });
      setFormErrorData({ ...errorObj });
      if (error) return;

      if (editingAddress) {
        dispatch(
          AccountActions.updateCustomerAddressAction(
            formData,
            customerInfo.customerId,
          ),
        );
      } else {
        dispatch(
          AccountActions.addCustomerAddressAction(
            formData,
            customerInfo.customerId,
          ),
        );
      }
    }
  };

  const handleDeleteAddress = (e, id) => {
    e.preventDefault();
    // setDeletingId(id);
    const address = addresses.find((a) => a.id === id);
    setAddressToDelete(address);
    setShowConfirm(true);
  };

  // Logic to perform the actual deletion after confirmation
  const confirmDelete = (e) => {
    e.stopPropagation();
    // setAddresses((prev) => prev.filter((a) => a.id !== addressToDelete.id));
    dispatch(
      AccountActions.removeCustomerAddressAction(
        customerInfo.customerId,
        addressToDelete.id,
      ),
    );
    setShowConfirm(false);
    setAddressToDelete(null);

    // const updatedAddresses = addresses.filter((addr) => addr.id !== deletingId);
    // setAddresses(updatedAddresses);

    // If we deleted the selected address, pick another one or null
    // if (selectedAddressId === deletingId) {
    //   // setSelectedAddressId(updatedAddresses.length > 0 ? updatedAddresses[0].id : null);
    // }
    // setDeletingId(null);
  };

  const closeConfirm = () => {
    setShowConfirm(false);
    setAddressToDelete(null);
  };

  return (
    <>
      {sortedAddresses.length > 0 && !editingAddress && (
        <>
          <div className="address-list">
            {sortedAddresses.map((addr) => (
              <div
                key={addr?.id}
                className={`address-item ${selectedAddressId?.id === addr?.id ? "selected" : ""} ${isAddressBeingRemoved ? "disabled" : ""}`}
                onClick={() => setSelectedAddressId(addr)}
              >
                {addressToDelete?.id === addr?.id && (
                  <div className="delete-confirm-overlay">
                    <p
                      style={{
                        fontWeight: 700,
                        fontSize: "0.9rem",
                        color: "#1f2937",
                        margin: 0,
                      }}
                    >
                      Delete this address?
                    </p>
                    <div className="confirm-actions">
                      <button
                        className="btn-sm btn-confirm"
                        onClick={confirmDelete}
                      >
                        DELETE
                      </button>
                      <button
                        className="btn-sm btn-cancel"
                        onClick={closeConfirm}
                      >
                        CANCEL
                      </button>
                    </div>
                  </div>
                )}
                {isCheckout && <div className="radio-circle"></div>}

                <div className="address-info" style={{ paddingRight: "4rem" }}>
                  <p
                    style={{
                      margin: "0 0 4px 0",
                      fontWeight: 700,
                      fontSize: "1rem",
                    }}
                  >
                    {addr?.addressName}
                    {addr?.defaultAddress && (
                      <span
                        style={{
                          color: "#3b82f6",
                          fontSize: "0.75rem",
                          marginLeft: "8px",
                        }}
                      >
                        (Default)
                      </span>
                    )}
                  </p>
                  <p
                    style={{
                      margin: "4px 0 0 0",
                      fontSize: "0.9rem",
                      color: "#374151",
                      lineHeight: "1.4",
                    }}
                  >
                    {addr?.email},{" "}
                  </p>
                  <p
                    style={{
                      margin: "4px 0 0 0",
                      fontSize: "0.9rem",
                      color: "#374151",
                      lineHeight: "1.4",
                    }}
                  >
                    {addr?.mobileNo},{" "}
                  </p>
                  <p
                    style={{
                      margin: "4px 0 0 0",
                      fontSize: "0.9rem",
                      color: "#374151",
                      lineHeight: "1.4",
                    }}
                  >
                    {addr?.address}, {addr?.city}, {addr?.state},{" "}
                    {addr?.country} - {addr?.zip}
                  </p>
                </div>
                <div className="item-actions">
                  <button
                    className="action-icon-btn edit"
                    onClick={(e) => {
                      handleOpenModal(e, addr);
                    }}
                    title="Edit Address"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                    </svg>
                  </button>
                  <button
                    className="action-icon-btn delete"
                    onClick={(e) => handleDeleteAddress(e, addr.id)}
                    title="Delete Address"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      {!isAddingNew && (
        <div className="add-new-toggle" onClick={(e) => handleOpenModal(e)}>
          <span>+</span>
          <span>Add a new address</span>
        </div>
      )}
      {isAddingNew && (
        <>
          {editingAddress && (
            <div
              className="back-btn"
              onClick={() => {
                setEditingAddress(null);
                setIsAddingNew(false);
              }}
            >
              <span>&larr;</span>
              <span>Back to list</span>
            </div>
          )}
          <Form
            className="cust-address-np-form"
            // onSubmit={handleSubmit}
          >
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label className="mobile-required">Name</Form.Label>
              <Form.Control
                type="text"
                name="addressName"
                value={formData.addressName}
                onChange={handleChange}
                required
                className="rounded-lg form-input"
              />
              {formErrorData?.addressName && (
                <div className="errormsg">{formErrorData?.addressName}</div>
              )}
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formZip">
                  <Form.Label className="mobile-required">Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="rounded-lg form-input"
                  />
                  {formErrorData?.email && (
                    <div className="errormsg">{formErrorData?.email}</div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="mobileNo">
                  <Form.Label className="mobile-required">Mobile</Form.Label>
                  <Col md={12}>
                    <PhoneNumberInput
                      value={formData.mobileNo}
                      required
                      inputName={"mobileNo"}
                      countryCodeName={"countryCode"}
                      updateInput={handleChange}
                      countryCode={formData.countryCode}
                      callback={setFormData}
                    />
                  </Col>
                  {formErrorData?.mobileNo && (
                    <div className="errormsg">{formErrorData?.mobileNo}</div>
                  )}
                  {formErrorData?.countryCode && (
                    <div className="errormsg">{formErrorData?.countryCode}</div>
                  )}
                </Form.Group>
              </Col>
              {/* <Form.Check
                controlId="formDefault"
                type="checkbox"
                // name="defaultAddress"
                label="Use Primary details"
                checked={isPrimaryInfo}
                onChange={(e) => setIsPrimaryInfo(e.target.checked)}
              /> */}
              {/* {isCheckout && (
                <Form.Group className="mb-3" controlId="formDefault">
                  <Form.Check
                    type="checkbox"
                    // name="defaultAddress"
                    label="Use Primary details"
                    checked={isPrimaryInfo}
                    onChange={(e) => setIsPrimaryInfo(e.target.checked)}
                  />
                </Form.Group>
              )} */}
            </Row>
            <hr />
            <Form.Group className="mb-3" controlId="formLine1">
              <Form.Label className="mobile-required">Address</Form.Label>
              <Form.Control
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
                className="rounded-lg form-input"
              />
              {formErrorData?.address && (
                <div className="errormsg">{formErrorData?.address}</div>
              )}
            </Form.Group>
            {/* <Form.Group className="mb-3" controlId="formLine2">
              <Form.Label>Address Line 2 (Optional)</Form.Label>
              <Form.Control
                type="text"
                name="addressLine2"
                value={formData.addressLine2}
                onChange={handleChange}
                className="rounded-lg"
              />
            </Form.Group> */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formCity">
                  <Form.Label className="mobile-required">City</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                    className="rounded-lg form-input"
                  />
                  {formErrorData?.city && (
                    <div className="errormsg">{formErrorData?.city}</div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formState">
                  <Form.Label className="mobile-required">State</Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    required
                    className="rounded-lg form-input"
                  />
                  {formErrorData?.state && (
                    <div className="errormsg">{formErrorData?.state}</div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formZip">
                  <Form.Label className="mobile-required">Zip Code</Form.Label>
                  <Form.Control
                    type="text"
                    name="zip"
                    value={formData.zip}
                    onChange={handleChange}
                    required
                    className="rounded-lg form-input"
                  />
                  {formErrorData?.zip && (
                    <div className="errormsg">{formErrorData?.zip}</div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="formCountry">
                  <Form.Label className="mobile-required">Country</Form.Label>
                  {/* <Form.Control
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={() => handleChange("country")}
                  required
                  className="rounded-lg"
                /> */}
                  <Form.Control
                    as="select"
                    name="country"
                    value={formData.country}
                    onChange={(e) => handleChange(e, "country")}
                    required
                    className="rounded-lg form-input"
                  >
                    {countryOptions}
                  </Form.Control>
                  {formErrorData?.country && (
                    <div className="errormsg">{formErrorData?.country}</div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3" controlId="formDefault">
              <Form.Check
                type="checkbox"
                name="defaultAddress"
                label="Set as Default Address"
                checked={formData.defaultAddress}
                onChange={handleChange}
              />
            </Form.Group>
            {!isCheckout && (
              <div className="d-grid gap-2 mt-4">
                <button
                  variant="primary"
                  type="button"
                  className="save-address-btn"
                  disabled={isAddressBeingAdded || isAddressBeingUpdated}
                  onClick={handleSaveAddress}
                >
                  {isAddressBeingAdded || isAddressBeingUpdated
                    ? "Loading.."
                    : "Save Address"}
                </button>
              </div>
            )}
          </Form>
        </>
      )}

      {isCheckout && (
        <button
          className={`save-address-btn ${isAddressBeingAdded || isAddressBeingUpdated ? "disabled" : ""}`}
          onClick={(e) => handleSaveAddress(e)}
          disabled={isAddressBeingAdded || isAddressBeingUpdated}
        >
          {editingAddress
            ? "UPDATE ADDRESS"
            : isAddingNew
              ? "SAVE AND USE"
              : "USE SELECTED ADDRESS"}
        </button>
      )}
    </>
  );
};

export default AddressBook;
